module.exports = __webpack_public_path__ + "static/media/styledmenu-arrow-down-primary.c76d2c22.svg";